module.exports = __webpack_public_path__ + "img/hedwig_in_cage.69e2a02c.jpg";